var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download-certificate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.41,93.07c0-7.8,12.27-7.8,12.27,0v23.41a6.51,6.51,0,0,1-6.32,6.31H31a6.51,6.51,0,0,1-6.32-6.31V93.07c0-7.8,12.64-7.8,12.64,0v17.09h75.09ZM80.07,84.89V28.09c0-7.06-10.78-7.06-10.78,0V85.27l-8.93-8.92c-4.83-5.2-12.26,2.6-7.43,7.43L70.77,102a5.68,5.68,0,0,0,7.44,0L96.42,83.78c5.21-5.2-2.6-12.63-7.8-7.43Z",
    transform: "translate(-24.68 -22.79)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCertificate);
export default __webpack_public_path__ + "static/media/download-certificate.6ca29a0ed35fc93d075ed68319d07701.svg";
export { ForwardRef as ReactComponent };